import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router'
import {EMPTY, Observable} from 'rxjs'
import {JobRequestRepository} from './job-request.repository'
import {LinkService} from '../../../core/i18n/link.service'
import {PUBLIC_ROUTES as PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {CLIENT_ROUTES} from '../../../shared/routing/client.routes'

@Injectable({
  providedIn: 'root',
})
export class JobRequestGuard {
  constructor(
    private readonly repo: JobRequestRepository,
    private readonly linkService: LinkService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<UrlTree> {
    const offering = this.repo.readJobRequestOfferingState()
    const detail = this.repo.readJobRequestDetailState()

    if (offering?.id || detail?.title) {
      return true
    }

    const recentJobNumber = this.repo.getRecentJobNumber()
    const offeringId = next.parent?.paramMap.get('offeringId')
    if (recentJobNumber) {
      this.linkService.navigateTo(CLIENT_ROUTES.CLIENT_JOB_DETAILS, {routeParams: {id: recentJobNumber}}).then()
    } else if (offeringId) {
      this.linkService
        .navigateTo(PUBLIC_ROUTES.JOB_REQUEST, {routeParams: {offeringId}, queryParams: next.queryParams})
        .then()
    } else {
      this.linkService.navigateTo(PUBLIC_ROUTES.HOME).then()
    }

    return EMPTY
  }
}
